import * as load from '../../../constants/types/shared/LoadingTypes';
import * as types from '../../../constants/types/procurement/ProcurementTypes';

export const releaseReducer = (state, action) => {
  const { payload, type } = action;
  switch (type) {
    case load.LOADING_STARTS:
      return {
        ...state,
        isLoading: true,
      };

    case load.LOADING_STOPS:
      return {
        ...state,
        isLoading: false,
      };

    case types.GET_PROCUREMENT_RELEASE:
      return {
        ...state,
        list: payload.list,
        count: payload.count,
        pages: payload.pages,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default releaseReducer;
